<template>
	<CModal title="Imprimer une étiquette" size="lg" :show.sync="showModal">
		<h4>#{{ orderItem.id }} - Génération d'étiquette</h4>
		<select-printer ref="printer" />

		<h4 style="color: red" v-if="isAlreadyPrinted">
			Attention: Cette étiquette a déjà été imprimée ! <br />
			Assurez-vous d'avoir bien déchiré la première étiquette imprimée !
		</h4>
		<h5 style="color: red" v-if="isScanned">Ce colis a déjà été bipé/scanné !</h5>

		<template #footer>
			<GLoadingButton :loading="loading" label="Imprimer" v-on:click="onSubmit" :disabled="isScanned" />
			<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
		</template>
	</CModal>
</template>

<script>
	import SelectPrinter from '../select-printer';
	import GLoadingButton from '../ghostlexly-components/GLoadingButton';
	export default {
		name: 'print-label-modal',
		components: { GLoadingButton, SelectPrinter },
		data() {
			return {
				showModal: false,
				orderItem: {},
				loading: false,
				isAlreadyPrinted: false,
				isScanned: false,
			};
		},

		watch: {
			orderItem(newVal) {
				this.$axios.get(newVal['@id']).then(res => {
					if (res.data.state === 'order_item.label_printed') {
						this.isAlreadyPrinted = true;
					} else if (res.data.state === 'order_item.scanned') {
						this.isScanned = true;
					} else {
						this.isAlreadyPrinted = false;
						this.isScanned = false;
					}
				});
			},
		},

		methods: {
			onSubmit() {
				if (!this.$qz.websocket.isActive()) {
					this.$toast.error(
						"Veuillez vous connecter à l'imprimante avant de pouvoir imprimer des étiquettes."
					);
					return false;
				}

				this.$axios
					.get(
						`${this.orderItem['@id']}/label?sendingDate=${this.$moment().format('YYYY-MM-DD')}`,
						{
							timeout: 3600000,
						}
					)
					.then(res => {
						this.$refs.printer.send(res.data.zpl).then(o => {
							this.loading = false;
							this.showModal = false;
							this.$emit('refresh');

							if (o === true) {
								this.$toast.success("Les étiquettes ont été transmises à l'imprimante.");
							} else {
								this.$toast.error(
									"Un problème est survenu lors de transmission des étiquettes à l'imprimante, veuillez vous rapprocher de l'administrateur pour remettre les étiquettes à disposition"
								);
							}
						});
					})
					.catch(err => {
						this.$toast.error(err.response.data['hydra:description']);
					});
			},
		},
	};
</script>
